import { render, staticRenderFns } from "./LotteryGame.vue?vue&type=template&id=03d2afb7&scoped=true&"
import script from "./LotteryGame.vue?vue&type=script&lang=js&"
export * from "./LotteryGame.vue?vue&type=script&lang=js&"
import style0 from "./LotteryGame.vue?vue&type=style&index=0&id=03d2afb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d2afb7",
  null
  
)

export default component.exports